import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { masterRefilling } from "../../rbac-consts";
import MasterRefillingsDetailsContainer from "./master/details/MasterRefillingsDetailsContainer";

const MasterRefillingsDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={masterRefilling.MASTER}
      yes={() => (
        <MasterRefillingsDetailsContainer match={match} />
      )}
    />
  );
};

export default MasterRefillingsDetailsWrapper;